export function addMessage(text, isUser = false) {
	const chatMessages = document.getElementById('chat-messages');

	const messageDiv = document.createElement('div');
	messageDiv.className = `flex items-start ${isUser ? 'justify-end' : ''}`;
	if (isUser) {
		messageDiv.innerHTML = `
<div class="bg-primary text-white rounded-2xl rounded-tr-sm px-4 py-3 max-w-[80%]">
<p>${text}</p>
</div>
`;
	} else {
		messageDiv.innerHTML = `
<div class="w-8 h-8 rounded-full overflow-hidden mr-2 flex-shrink-0">
<img src="/VX/VXMetaChat/img/lia.jpg" alt="Lia" class="w-full h-full object-cover">
</div>
<div class="bg-gray-100 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[80%]">
<p class="text-gray-900">${text}</p>
</div>
`;
	}
	chatMessages.appendChild(messageDiv);
	chatMessages.scrollTop = chatMessages.scrollHeight;
}
